import AnimatedPetitoLogo from './AnimatedPetitoLogo';

export type LoadingSplashProps = {
    /**
     * CSS layered logo only (GIF removed from product UX — black plate + heavy).
     * `variant` kept for call-site compat; both map to CSS.
     */
    variant?: 'gif' | 'css';
    /** Full viewport overlay vs inline block */
    fullScreen?: boolean;
    label?: string;
    className?: string;
};

/**
 * Loading splash: playful Petito CSS animation + optional label.
 * Cream shell — no GIF / black plate.
 */
const LoadingSplash = ({
    fullScreen = true,
    label,
    className = '',
}: LoadingSplashProps) => {
    const shell = fullScreen
        ? `petito-splash ${className}`.trim()
        : `flex flex-col items-center justify-center gap-4 py-10 ${className}`.trim();

    return (
        <div className={shell} role="status" aria-live="polite" aria-busy="true">
            <AnimatedPetitoLogo size={fullScreen ? 'xl' : 'md'} playful mode="css" decorative />
            {label ? (
                <p className={fullScreen ? 'petito-splash__label' : 'text-base text-[var(--text-color)]/80'}>
                    {label}
                </p>
            ) : null}
        </div>
    );
};

export default LoadingSplash;
